import { render, staticRenderFns } from "./HotOferta.html?vue&type=template&id=25bfab05&scoped=true&external"
import script from "./HotOferta.js?vue&type=script&lang=js&external"
export * from "./HotOferta.js?vue&type=script&lang=js&external"
import style0 from "./HotOferta.css?vue&type=style&index=0&id=25bfab05&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bfab05",
  null
  
)

export default component.exports